export default "__VITE_ASSET__C3ybxaX1__"